import { type DatabaseChangeType } from '@databases/types/redux';

import { fieldToCollabJSON } from '../../../collab/convert-to-collab';
import { type YJSChangeHandler } from '../../types';

export const addField: YJSChangeHandler<DatabaseChangeType.ADD_FIELD> = ({
  ydb,
  change,
}) => {
  ydb.mutate((db) => {
    if (change.index != null) {
      db.addFieldAt(change.field.id, fieldToCollabJSON(change.field, {}), change.index);
    } else {
      db.addFieldFromJSON(change.field.id, fieldToCollabJSON(change.field, {}));
    }

    db.views.forEach((viewId: string) => {
      if (db.viewsById[viewId] && db.viewsById[viewId].fields) {
        db.viewsById[viewId].setFieldVisibility(change.field.id, true, db.fields, {
          includeNewFieldInValidation: true,
        });
      }
    });
  });
};
